import DOMPurify from "dompurify";

export default function purify(value) {
  return DOMPurify.sanitize(value);
}
